import { useProviders, useSubscriptions } from '../api/queries.js';
import { Badge, Card, Loading, Page, Problem, Table } from '../components/ui.jsx';
import { formatDateTime } from '../utils/format.js';

/**
 * What physically carries the channels, and who is listening.
 *
 * The providers that are not available yet are shown on purpose: the shape of each adapter is
 * decided before anyone writes it, and no application will ever notice when a channel moves from
 * one to another — that is the whole point of the abstraction.
 */
export function Providers() {
  const providers = useProviders();
  const subscriptions = useSubscriptions();

  if (providers.isLoading) return <Loading what="i provider" />;
  if (providers.error) return <Problem error={providers.error} />;

  return (
    <Page eyebrow="CONFIGURA" title="Providers" description="Il trasporto sotto i canali, e le sottoscrizioni attive.">
      <div className="provider-grid">
        {providers.data!.providers.map((provider) => (
          <Card key={provider.name} className={provider.available ? '' : 'dim'}>
            <header className="card-header">
              <h2>{provider.title}</h2>
              <Badge tone={provider.available ? 'good' : 'neutral'}>{provider.available ? 'disponibile' : 'previsto'}</Badge>
            </header>
            <p className="muted small">{provider.notes}</p>
            <ul className="features">
              <li className={provider.features.ordering ? 'yes' : 'no'}>ordinamento</li>
              <li className={provider.features.competingConsumers ? 'yes' : 'no'}>consumatori in concorrenza</li>
              <li className={provider.features.nativeDeadLetter ? 'yes' : 'no'}>dead letter native</li>
              <li className={provider.features.delayedDelivery ? 'yes' : 'no'}>consegna ritardata</li>
            </ul>
            <p className="muted small">{provider.channels} canali su questo provider</p>
          </Card>
        ))}
      </div>

      <Card title="Sottoscrizioni">
        <Table
          head={
            <tr>
              <th>Applicazione</th>
              <th>Canale</th>
              <th>Modo</th>
              <th>Endpoint</th>
              <th>Dal</th>
            </tr>
          }
          empty="Nessuna sottoscrizione: finché nessuno ascolta, i messaggi non vengono accodati a nessuno."
        >
          {(subscriptions.data?.subscriptions ?? []).map((subscription) => (
            <tr key={`${subscription.application}-${subscription.channel}`}>
              <td>{subscription.application}</td>
              <td>{subscription.channel}</td>
              <td>
                <Badge tone="info">{subscription.mode}</Badge>
              </td>
              <td className="muted small">{subscription.endpoint ?? '—'}</td>
              <td className="muted small">{formatDateTime(subscription.createdAt)}</td>
            </tr>
          ))}
        </Table>
      </Card>
    </Page>
  );
}
